import { HELP_ITEM_ID } from '@common/components/HelpMenu/help-menu.const'

export const HELP_DRAWER_SELECT_LAYER_CLASS = 'help-drawer-select-layer'

export const RESET_VIEW_AFTER_CLOSE_MS = 300

export const HELP_DRAWER_VIEW = {
  MENU: 'menu',
  FEEDBACK: 'feedback',
} as const

export const ITEMS_WITH_SUB_FLOW = new Set<string>([HELP_ITEM_ID.SHARE_FEEDBACK])
